// extracted by mini-css-extract-plugin
export var base = "_3q-0";
export var updateBanner = "_3q-1";